import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";
import { Field } from "../components/Field";
import { api } from "../api/client";

/** FR-AUTH-03 — request a reset link. */
export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    try {
      await api("/auth/password-reset/request", {
        method: "POST",
        body: { email },
        auth: false,
      });
    } catch {
      // Deliberately swallowed. The API answers 204 whether or not the account
      // exists, and the UI must not become the enumeration oracle the API
      // avoids being — so a failure here shows the same confirmation.
    }
    setSent(true);
    setSubmitting(false);
  }

  if (sent) {
    return (
      <AuthLayout
        title="Check your email"
        subtitle={
          <>
            If an account exists for <strong>{email}</strong>, we've sent a
            reset link. It expires in one hour.
          </>
        }
        footer={<Link to="/login">Back to sign in</Link>}
      >
        <Link className="btn btn--secondary btn--block" to="/login">
          Back to sign in
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="We'll email you a link to set a new one."
      footer={<Link to="/login">Back to sign in</Link>}
    >
      <form onSubmit={handleSubmit} noValidate>
        <Field
          label="Email"
          type="email"
          name="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button
          type="submit"
          className="btn btn--primary btn--block"
          disabled={submitting}
        >
          {submitting ? "Sending…" : "Send reset link"}
        </button>
      </form>
    </AuthLayout>
  );
}
